export default __webpack_public_path__ + "static/media/fake-latin-news-screenshot.c0b7af55.png";